<div class="flex flex-col">
	<ui-content-header [title]="title">
		<ng-container actions>
			<img
				src="/assets/images/integrations/sync-logo.png"
				alt="Closer SYNC"
				class="w-14"
			/>
		</ng-container>
	</ui-content-header>

	<div class="flex-1 flex overflow-y-scroll">
		<div class="grid grid-cols-2 gap-6 pb-8">
			<!-- {{requestForFunds | json}} -->
			<ui-section title="Mortgage">
				<div section-content uiInfoRowList>
					<ui-info-row
						infoLabel="Mortgage Loan Number"
						[infoValue]="requestForFunds?.mortgage?.mortgageLoanNumber"
					/>
					<ui-info-row
						infoLabel="Charge Type"
						[infoValue]="requestForFunds?.mortgage?.chargeType"
					/>
					<ui-info-row
						infoLabel="Mortgage Priority"
						[infoValue]="
							requestForFunds?.mortgage?.mortgagePriority | ordinalSuffix
						"
					/>
					<ui-info-row
						infoLabel="Principal Amount"
						[infoValue]="
							requestForFunds?.mortgage?.principalAmount | centsToDollars
						"
					/>
					<ui-info-row
						infoLabel="Net Advanced"
						[infoValue]="
							requestForFunds?.mortgage?.netAdvanced | centsToDollars
						"
					/>
					<ui-info-row
						infoLabel="Amount Type"
						[infoValue]="requestForFunds?.mortgage?.amountType"
					/>
					<ui-info-row
						infoLabel="Interest Adjustment Date"
						[infoValue]="
							requestForFunds?.mortgage?.interestAdjustmentDateAsReg | date
						"
					/>
					<ui-info-row
						infoLabel="Closing Date"
						[infoValue]="requestForFunds?.mortgage?.closingDate | date"
					/>
				</div>
			</ui-section>
			<ui-section title="Property">
				<div section-content uiInfoRowList>
					<ui-info-row infoLabel="Address">
						<ui-address [address]="requestForFunds?.properties[0]?.address" />
					</ui-info-row>
					<ui-info-row infoLabel="PIN">
						<ng-container
							*ngIf="requestForFunds?.properties[0]?.pins.length; else noValue"
						>
							<p *ngFor="let pin of requestForFunds?.properties[0]?.pins">
								{{ pin }}
							</p>
						</ng-container>
						<ng-template #noValue>
							<p class="text-gray-500">-</p>
						</ng-template>
					</ui-info-row>
					<ui-info-row
						infoLabel="Legal Description"
						[infoValue]="requestForFunds?.properties[0]?.legalDescription"
					/>
					<ui-info-row
						infoLabel="Municipal Tax Office"
						[infoValue]="requestForFunds?.properties[0]?.municipality"
					/>
					<ui-info-row
						infoLabel="Roll Number"
						[infoValue]="requestForFunds?.properties[0]?.rollNumbers"
					/>
					<ui-info-row
						infoLabel="Annual Tax Amount"
						[infoValue]="
							requestForFunds?.properties[0]?.annualTaxAmount | centsToDollars
						"
					/>
					<ui-info-row
						infoLabel="Taxes Paid To"
						[infoValue]="requestForFunds?.properties[0]?.taxesPaidTo | date"
					/>
					<ui-info-row
						infoLabel="Next Installment Date"
						[infoValue]="
							requestForFunds?.properties[0]?.nextInstallmentDate | date
						"
					/>
					<ui-info-row
						infoLabel="Taxes Outstanding"
						[infoValue]="requestForFunds?.properties[0]?.taxesOutstanding"
					/>
					<ui-info-row
						infoLabel="Tax Amount In Arrears"
						*ngIf="requestForFunds?.properties[0]?.taxesOutstanding"
						[infoValue]="
							requestForFunds?.properties[0]?.taxAmountInArrears
								| centsToDollars
						"
					/>
				</div>
			</ui-section>
			<ui-section
				title="Existing Mortgages"
				*ngIf="requestForFunds?.properties[0]?.existingMortgages?.length > 0"
			>
				<div section-content uiInfoRowList>
					<ui-card
						*ngFor="
							let existingMortgage of requestForFunds?.properties[0]
								?.existingMortgages
						"
					>
						<div card-content uiInfoRowList>
							<ui-info-row
								infoLabel="Action"
								[infoValue]="existingMortgage.action"
							></ui-info-row>
							<ui-info-row
								infoLabel="Lender Name"
								[infoValue]="existingMortgage.lenderName"
							></ui-info-row>
							<ui-info-row
								infoLabel="Postponed"
								[infoValue]="existingMortgage.postponed"
							></ui-info-row>
							<ui-info-row
								infoLabel="Registration Method"
								[infoValue]="existingMortgage.registrationMethod"
							></ui-info-row>
							<ui-info-row
								infoLabel="Registration Number"
								[infoValue]="existingMortgage.registrationNumber"
							></ui-info-row>
							<ui-info-row
								infoLabel="Remain Priority"
								[infoValue]="existingMortgage.remainPriority"
							></ui-info-row>
							<ui-info-row
								infoLabel="Remaining Amount"
								[infoValue]="existingMortgage.remainingAmount | centsToDollars"
							></ui-info-row>
							<ui-info-row
								infoLabel="Undertaking Selection"
								[infoValue]="existingMortgage.undertakingSelection"
							></ui-info-row>
						</div>
					</ui-card>
				</div>
			</ui-section>
			<ui-section
				title="Fire Insurance"
				*ngIf="requestForFunds?.properties[0]?.fireInsurance"
			>
				<div section-content uiInfoRowList>
					<ui-info-row
						[infoLabel]="'Fire Insurance Company'"
						[infoValue]="
							requestForFunds?.properties[0]?.fireInsurance
								?.fireInsuranceCompany || null
						"
					/>
					<ui-info-row
						[infoLabel]="'Amount'"
						[infoValue]="
							requestForFunds?.properties[0]?.fireInsurance?.amount || null
						"
					/>
					<ui-info-row
						[infoLabel]="'Policy Number'"
						[infoValue]="
							requestForFunds?.properties[0]?.fireInsurance?.policyNumber
						"
					/>
					<ui-info-row
						[infoLabel]="'Active Date'"
						[infoValue]="
							requestForFunds?.properties[0]?.fireInsurance?.activeDate | date
						"
					/>
					<ui-info-row
						[infoLabel]="'Expiry Date'"
						[infoValue]="
							requestForFunds?.properties[0]?.fireInsurance?.expiryDate | date
						"
					/>
					<ui-info-row
						*ngIf="
							requestForFunds?.properties[0]?.fireInsurance?.beneficiaryBranch
								?.payee
						"
						[infoLabel]="'Beneficiary Branch Payee'"
						[infoValue]="
							requestForFunds?.properties[0]?.fireInsurance?.beneficiaryBranch
								?.payee
						"
					/>
					<ui-info-row
						*ngIf="
							requestForFunds?.properties[0]?.fireInsurance?.beneficiaryBranch
								?.address
						"
						[infoLabel]="'Beneficiary Branch Address'"
					>
						<ui-address
							[address]="
								requestForFunds?.fireInsurance?.beneficiaryBranch?.address
							"
						/>
					</ui-info-row>
					<ui-info-row
						[infoLabel]="'Guaranteed Replacement Coverage'"
						[infoValue]="
							requestForFunds?.properties[0]?.fireInsurance
								?.guaranteedReplacementCoverage
						"
					/>
				</div>
			</ui-section>
			<ui-section title="Mortgagors">
				<div class="section-content" section-content>
					<ng-container *ngFor="let mortgagor of requestForFunds?.mortgagors">
						<ui-section
							type="sub-section"
							[title]="
								mortgagor.companyName ||
								mortgagor.firstName + ' ' + mortgagor.lastName
							"
						>
							<div section-content uiInfoRowList>
								<ng-template-outlet
									[ngTemplateOutlet]="
										mortgagor.mortgagorType === 'PERSON'
											? personTemplate
											: businessTemplate
									"
									[ngTemplateOutletContext]="{ mortgagor: mortgagor }"
								>
								</ng-template-outlet>

								<!-- Person Type -->
								<ng-template #personTemplate let-mortgagor="mortgagor">
									<ui-info-row
										[infoLabel]="'First Name'"
										[infoValue]="mortgagor.firstName"
									></ui-info-row>
									<ui-info-row
										[infoLabel]="'Middle Name'"
										[infoValue]="mortgagor.middleName"
									></ui-info-row>
									<ui-info-row
										[infoLabel]="'Last Name'"
										[infoValue]="mortgagor.lastName"
									></ui-info-row>
								</ng-template>

								<!-- Business Type -->
								<ng-template #businessTemplate let-mortgagor="mortgagor">
									<ui-info-row
										[infoLabel]="'Company Name'"
										[infoValue]="mortgagor.companyName"
									></ui-info-row>
								</ng-template>

								<!-- Phone -->
								<ui-info-row
									*ngIf="mortgagor.phone"
									[infoLabel]="'Phone'"
									[infoValue]="mortgagor.phone"
								></ui-info-row>

								<!-- Address Details -->
								<ng-container *ngIf="mortgagor.address">
									<ui-info-row infoLabel="Address">
										<ui-address [address]="mortgagor.address" />
									</ui-info-row>
								</ng-container>

								<!-- Identifications -->
								<div *ngIf="mortgagor.identifications?.length > 0">
									<h4 class="h4 mb-2">Identifications:</h4>
									<div uiInfoRowList>
										<ui-card *ngFor="let id of mortgagor.identifications">
											<div card-content uiInfoRowList>
												<ui-info-row
													[infoLabel]="'ID Type'"
													[infoValue]="id.type"
												></ui-info-row>
												<ui-info-row
													[infoLabel]="'ID Number'"
													[infoValue]="id.number"
												></ui-info-row>
												<ui-info-row
													[infoLabel]="'Expiry Date'"
													[infoValue]="id.expiryDate | date"
												></ui-info-row>
												<ui-info-row
													[infoLabel]="'Issuing Jurisdiction'"
													[infoValue]="id.issuingJurisdiction"
												></ui-info-row>
												<ui-info-row
													[infoLabel]="'Issuing Country'"
													[infoValue]="id.issuingCountry"
												></ui-info-row>
												<ui-info-row
													[infoLabel]="'Verified On'"
													[infoValue]="id.verfiedOn"
												></ui-info-row>
												<ui-info-row
													[infoLabel]="'Name on ID'"
													[infoValue]="id.name"
												></ui-info-row>
											</div>
										</ui-card>
									</div>
								</div>
							</div>
						</ui-section>
					</ng-container>
				</div>
			</ui-section>

			<ui-section title="Guarantors">
				<div class="section-content">
					<ng-container *ngFor="let guarantor of requestForFunds?.guarantors">
						<ui-section
							type="sub-section"
							[title]="
								guarantor.companyName ||
								guarantor.firstName + ' ' + guarantor.lastName
							"
						>
							<div section-content uiInfoRowList>
								<ng-template-outlet
									[ngTemplateOutlet]="
										guarantor.guarantorType === 'PERSON'
											? personTemplate
											: businessTemplate
									"
									[ngTemplateOutletContext]="{ guarantor: guarantor }"
								>
								</ng-template-outlet>

								<!-- Person Type -->
								<ng-template #personTemplate let-guarantor="guarantor">
									<ui-info-row
										[infoLabel]="'First Name'"
										[infoValue]="guarantor.firstName"
									></ui-info-row>
									<ui-info-row
										[infoLabel]="'Middle Name'"
										[infoValue]="guarantor.middleName"
									></ui-info-row>
									<ui-info-row
										[infoLabel]="'Last Name'"
										[infoValue]="guarantor.lastName"
									></ui-info-row>
								</ng-template>

								<!-- Business Type -->
								<ng-template #businessTemplate let-guarantor="guarantor">
									<ui-info-row
										[infoLabel]="'Company Name'"
										[infoValue]="guarantor.companyName"
									></ui-info-row>
								</ng-template>

								<!-- Phone -->
								<ui-info-row
									*ngIf="guarantor.phone"
									[infoLabel]="'Phone'"
									[infoValue]="guarantor.phone"
								></ui-info-row>

								<!-- Address Details -->
								<ng-container *ngIf="guarantor.address">
									<ui-info-row infoLabel="Address">
										<ui-address [address]="guarantor.address" />
									</ui-info-row>
								</ng-container>

								<!-- Identifications -->
								<div *ngIf="guarantor.identifications?.length > 0">
									<h4 class="h4 mb-2">Identifications:</h4>
									<div uiInfoRowList>
										<ui-card *ngFor="let id of guarantor.identifications">
											<div card-content uiInfoRowList>
												<ui-info-row
													[infoLabel]="'ID Type'"
													[infoValue]="id.type"
												></ui-info-row>
												<ui-info-row
													[infoLabel]="'ID Number'"
													[infoValue]="id.number"
												></ui-info-row>
												<ui-info-row
													[infoLabel]="'Expiry Date'"
													[infoValue]="id.expiryDate | date"
												></ui-info-row>
												<ui-info-row
													[infoLabel]="'Issuing Jurisdiction'"
													[infoValue]="id.issuingJurisdiction"
												></ui-info-row>
												<ui-info-row
													[infoLabel]="'Issuing Country'"
													[infoValue]="id.issuingCountry"
												></ui-info-row>
												<ui-info-row
													[infoLabel]="'Verified On'"
													[infoValue]="id.verfiedOn"
												></ui-info-row>
												<ui-info-row
													[infoLabel]="'Name on ID'"
													[infoValue]="id.name"
												></ui-info-row>
											</div>
										</ui-card>
									</div>
								</div>
							</div>
						</ui-section>
					</ng-container>
				</div>
			</ui-section>
			<ui-section title="Title Insurance">
				<div section-content uiInfoRowList>
					<ui-info-row
						*ngIf="requestForFunds?.titleInsurance?.requirementConfirmation"
						[infoLabel]="'Solicitor Certification'"
						[infoValue]="
							requestForFunds?.titleInsurance?.requirementConfirmation
						"
					/>
					<ui-info-row
						*ngIf="requestForFunds?.titleInsurance?.companyName"
						[infoLabel]="'Company Name'"
						[infoValue]="requestForFunds?.titleInsurance?.companyName"
					/>
					<ui-info-row
						*ngIf="requestForFunds?.titleInsurance?.insured"
						[infoLabel]="'Insured'"
						[infoValue]="requestForFunds?.titleInsurance?.insured"
					/>
					<ui-info-row
						*ngIf="requestForFunds?.titleInsurance?.policyNumber"
						[infoLabel]="'Policy Number'"
						[infoValue]="requestForFunds?.titleInsurance?.policyNumber"
					/>
					<ui-info-row
						*ngIf="requestForFunds?.titleInsurance?.policyDate"
						[infoLabel]="'Policy Date'"
						[infoValue]="requestForFunds?.titleInsurance?.policyDate | date"
					/>
					<ui-info-row
						*ngIf="requestForFunds?.titleInsurance?.amount"
						[infoLabel]="'Amount'"
						[infoValue]="
							requestForFunds?.titleInsurance?.amount | centsToDollars
						"
					/>
				</div>
			</ui-section>

			<ui-section
				title="Funding Details"
				*ngIf="requestForFunds?.fundingDetails"
			>
				<div section-content uiInfoRowList>
					<ui-info-row
						[infoLabel]="'Funding Method'"
						[infoValue]="
							requestForFunds?.fundingDetails?.fundingMethod | fundingMethod
						"
					/>
					<div
						class="grid grid-cols-2 gap-4 border-t mt-4 pt-4 border-gray-200"
					>
						<div>
							<div class="h4 mb-2">Trust Account</div>
							<ui-card background="gray">
								<ng-container card-content>
									<ui-info-row
										[infoLabel]="'Name'"
										[infoValue]="
											requestForFunds?.trustAccount?.financialInstitution?.name
										"
									/>
									<ui-info-row
										[infoLabel]="'Institution'"
										[infoValue]="
											requestForFunds?.trustAccount?.financialInstitution
												?.institution
										"
									/>
									<ui-info-row
										[infoLabel]="'Account'"
										[infoValue]="
											requestForFunds?.trustAccount?.financialInstitution
												?.account
										"
									/>
									<ui-info-row
										[infoLabel]="'Transit'"
										[infoValue]="
											requestForFunds?.trustAccount?.financialInstitution
												?.transit
										"
									/>
									<ui-info-row [infoLabel]="'Address'">
										<ui-address
											[address]="
												requestForFunds?.trustAccount?.financialInstitution
													?.address
											"
										/>
									</ui-info-row>
								</ng-container>
							</ui-card>
						</div>
						<div>
							<div class="h4 mb-2">Branch</div>
							<ui-card>
								<ng-container card-content>
									<ui-info-row
										[infoLabel]="'Name'"
										[infoValue]="
											requestForFunds?.trustAccount?.localBranch?.name
										"
									/>
									<ui-info-row
										[infoLabel]="'Institution'"
										[infoValue]="
											requestForFunds?.trustAccount?.localBranch?.institution
										"
									/>
									<ui-info-row
										[infoLabel]="'Transit'"
										[infoValue]="
											requestForFunds?.trustAccount?.localBranch?.transit
										"
									/>
									<ui-info-row [infoLabel]="'Address'">
										<ui-address
											[address]="
												requestForFunds?.trustAccount?.localBranch?.address
											"
										/>
									</ui-info-row>
								</ng-container>
							</ui-card>
						</div>
					</div>
				</div>
			</ui-section>
		</div>
	</div>

	<div class="flex justify-between pt-4 px-4 border-t border-gray-200">
		<ui-button label="Cancel" (click)="cancel()" [style]="'outline'" />
		<ui-button
			[label]="
				requestType === 'REQUEST_FOR_FUNDS'
					? 'Generate Request for Funds'
					: 'Generate Final Report'
			"
			(click)="submit()"
			[loading]="submitting$ | async"
			[disabled]="submitting$ | async"
		/>
	</div>
</div>
